module.exports = __webpack_public_path__ + "static/media/red-chips-reward.83c69fc7.svg";